<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="pt2"> </p>
<p class="PN"><span epub:type="pagebreak" id="pg_43" title="43"><span href="#/xhtml/contents#p_pt2" title="Link target outside of Sample"><span class="ePub-I">Zarnika</span></span></span></p>
<p class="Part-Opening-Text-No-Indent-potx1"><span class="ePub-SC">DESCRIPTION:</span> Naturally occurring mineral, brittle and gray, often with a colorless, odorless crystalline coating, soluble in water. Poisonous to ingest directly or through plants or water supplies in high concentration areas. Poison can also be absorbed through skin.</p>
<p class="Part-Opening-Text-potx"><span class="ePub-SC">SYMPTOMS:</span> Facial swelling, acute abdominal pain, vomiting, diarrhea, leading into coma and death.</p>
<p class="Part-Opening-Text-potx"><span class="ePub-SC">PROOFING CUES:</span> Subtle, sweet, and slightly metallic flavor, difficult to detect at low levels or in sweet dishes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?67205351